import { BaseWebComponentElement } from '../../../../../framework/BaseWebComponentElement';
import { IntegrityMonitorCustomRuleActionItemController } from '../controller/IntegrityMonitorCustomRuleActionItemController';
import { IntegrityMonitorCustomRulesAttribute } from '../../../../common/utils/types';

export class IntegrityMonitorCustomRuleActionItemWebComponent extends BaseWebComponentElement {
  public controller!: IntegrityMonitorCustomRuleActionItemController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: IntegrityMonitorCustomRuleActionItemController,
    });
  }

  public set options(opts: IntegrityMonitorCustomRulesAttribute) {
    this.controller.setOptions(opts);
  }

  public refreshOptions(os: string) {
    this.controller.refreshOptions(os);
  }
}
